import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { caseStudiesData } from '../data/caseStudies';

const CaseStudiesOverview = () => {
  const { t, lang } = useLanguage();

  return (
    <div className="bg-zinc-950 min-h-screen pt-32 pb-24 px-6">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-20"
        >
          <h1 className="text-4xl md:text-6xl font-black text-white tracking-tighter mb-4">
            {t.caseStudies.header}
          </h1>
          <div className="w-24 h-1 bg-orange-500 mx-auto rounded-full" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {caseStudiesData.map((study, index) => (
            <motion.div
              key={study.slug}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="group bg-zinc-900 border border-white/5 rounded-3xl overflow-hidden hover:border-orange-500/30 transition-all duration-500"
            >
              {study.image ? (
                <div className="aspect-video relative overflow-hidden">
                  <img
                    src={study.image}
                    alt={`${study.clientName} ${lang === 'es' ? 'caso de éxito' : 'case study'}`}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-transparent to-transparent opacity-60" />
                  <div className="absolute bottom-6 left-6">
                    <span className="px-3 py-1 bg-orange-500 text-white text-[10px] font-bold uppercase tracking-widest rounded-full">
                      {study.category}
                    </span>
                  </div>
                </div>
              ) : (
                <div className="px-8 pt-8">
                  <span className="px-3 py-1 bg-orange-500 text-white text-[10px] font-bold uppercase tracking-widest rounded-full">
                    {study.category}
                  </span>
                </div>
              )}

              <div className="p-8">
                <h2 className="text-zinc-500 text-sm font-bold uppercase tracking-widest mb-2">
                  {study.website ? (
                    <a
                      href={study.website}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-orange-500 transition-colors"
                    >
                      {study.clientName}
                    </a>
                  ) : (
                    study.clientName
                  )}
                </h2>
                <h3 className="text-2xl font-bold text-white mb-6 group-hover:text-orange-400 transition-colors">
                  {study[lang].title}
                </h3>
                <Link
                  to={`/case-studies/${study.slug}`}
                  className="inline-flex items-center gap-2 text-white font-bold text-sm uppercase tracking-widest hover:text-orange-500 transition-colors"
                >
                  {t.caseStudies.viewFull}
                  <span className="text-orange-500">→</span>
                </Link>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CaseStudiesOverview;